export default __webpack_public_path__ + "static/media/user-circle-o.8f7964d0.svg";